import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

import { Areas } from './areas';
import { Baths } from './baths';
import { Beds } from './beds';
import { Garage } from './garage';
import { Homesites } from './homesites';
import { Ids } from './ids';
import { MinimumSquareFeet } from './minimum-square-feet';
import { Models } from './model';
import { OpenHomes } from './open-homes';
import { PendingSales } from './pending-sales';
import { Pool } from './pool';
import { PriceHigh } from './price-high';
import { PriceLow } from './price-low';
import { Reps } from './reps';
import { SaleTypeHomesite } from './sale-type-homesite';
import { SaleTypeNew } from './sale-type-new';
import { SaleTypePreowned } from './sale-type-preowned';
import { Series } from './series';
import { ULIKey } from './uli-key';
import { Unit } from './unit';

export function FilteredListings(this: ListingsService): Listing[] {
  let output: Listing[] = [...this.allListings()];

  if (this.filteringService.reps()) {
    output = output.filter((l) => {
      let included = true;
      included = Reps.call(this, l, included);
      return included;
    });

    return output;
  }

  if (!output.length) {
    return [];
  }

  if (this.filteringService.dreamHomes()) {
    const _savedIds = this.filteringService
      .userSavedListingIds()
      .map((l) => l.itemId)
      .filter((id): id is string => id !== '');

    if (_savedIds.length === 0) {
      return [];
    }

    output = output.filter((l) => _savedIds.includes(l.id || ''));
  }

  if (this.filteringService.ids().length > 0) {
    output = Ids.call(this);
  }

  if (!this.filteringService.ignoreFilters()) {
    output = output.filter((l) => {
      let included = true;

      included = Areas.call(this, l, included);
      included = Baths.call(this, l, included);
      included = Beds.call(this, l, included);
      included = Garage.call(this, l, included);
      included = Homesites.call(this, l, included);
      included = MinimumSquareFeet.call(this, l, included);
      included = Models.call(this, l, included);
      included = OpenHomes.call(this, l, included);
      included = PendingSales.call(this, l, included);
      included = Pool.call(this, l, included);
      included = PriceHigh.call(this, l, included);
      included = PriceLow.call(this, l, included);
      included = Reps.call(this, l, included);
      included = SaleTypeHomesite.call(this, l, included);
      included = SaleTypeNew.call(this, l, included);
      included = SaleTypePreowned.call(this, l, included);
      included = Series.call(this, l, included);
      included = ULIKey.call(this, l, included);
      included = Unit.call(this, l, included);

      return included;
    });
  }

  return output;
}
